import axios from 'axios'

const state = {
  clients: [],
  homeClients: []
}

const actions = {
  LOAD_CLIENTS ({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_BASE_URL + 'api/clients/')
        .then((response) => {
          commit('SET_CLIENTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  LOAD_HOME_CLIENTS ({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_BASE_URL + 'api/home/clients/')
        .then((response) => {
          commit('SET_HOME_CLIENTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
}

const getters = {
}

const mutations = {
  SET_CLIENTS (state, payload) {
    state.clients = payload
  },
  SET_HOME_CLIENTS (state, payload) {
    state.homeClients = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
